module.exports = "/dist/img/noshi05.d71a3f12.jpg";